import { Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';

/*
    The blocking overlay the Angular save panel showed while a save was in flight. A course save
    can take a while, so the admin needs to see that something is happening and that the form is
    locked.

    `title` exists because the cohort editor says 'Saving & Publishing' when the publish box is
    checked, which is what its Angular modal did.
*/
export default function SavingOverlay({ open, title = 'Saving' }: { open: boolean; title?: string }) {
    return (
        <Dialog open={open} maxWidth="xs">
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <Typography>Please wait...</Typography>
            </DialogContent>
        </Dialog>
    );
}
